import { LoanConditionsGroup } from '@/components/modules/Application/components/PaymentMethod/_shared/entities/ConditionsGroup/LoanConditionsGroup';
import { LoanConditions } from '@/components/modules/Application/components/PaymentMethod/_shared/types/LoanConditions';

export class ConsumerLoanConditionsGroup extends LoanConditionsGroup {
  public readonly hasSetupFee: boolean;
  public readonly hasGracePeriod: boolean;
  public readonly hasMerchantDiscountPercentage: boolean;

  constructor(public readonly conditions: LoanConditions[]) {
    super(conditions);
    this.hasSetupFee = ConsumerLoanConditionsGroup.getHasSetupFee(conditions);
    this.hasGracePeriod = ConsumerLoanConditionsGroup.getHasGracePeriod(conditions);
    this.hasMerchantDiscountPercentage = ConsumerLoanConditionsGroup.getHasMerchantDiscountPercentage(conditions);
  }

  public static getHasSetupFee(conditions: LoanConditions[]): boolean {
    return conditions.some((condition) => condition.setupFee?.value && condition.setupFee.value > 0);
  }

  public static getHasGracePeriod(conditions: LoanConditions[]): boolean {
    return conditions.some((condition) => condition.gracePeriod && condition.gracePeriod > 0);
  }

  public static getHasMerchantDiscountPercentage(conditions: LoanConditions[]): boolean {
    return conditions.some(
      (condition) => condition.merchantDiscountPercentage && condition.merchantDiscountPercentage.value > 0,
    );
  }

  public addCondition(condition: LoanConditions): void {
    this.conditions.push(condition);
  }
}
